import React from "react";
import DoctorDetailPage from "./DoctorDetailPage";

const DrGayatriNavaleContent = () => {
  return (
    <DoctorDetailPage
      name="Dr. Gayatri Navale"
      specialization="Your Safe Space to Share"
      experience="13 Years"
      degrees="MBBS, MS (Obs & Gyn) from University Name"
      quote="I believe I am becoming a pregnancy crafter who makes room for every fear, doubt, and question."
      sections={[
        {
          title: "My Philosophy on Pregnancy Care",
          body: "My entire practice is built on a foundation of empathy. I understand that pregnancy brings a whirlwind of emotions, and my primary role is to create a safe, confidential space where you can voice every single one. I listen more than I talk. By truly hearing you, I can better understand your needs and we can navigate this path as a team, with trust and mutual respect at the core of everything we do.",
        },
        {
          title: "Why I Chose Myprega",
          body: "The Myprega philosophy of care like a mother is what medicine should be. The system's emphasis on regular, personal calls and counselling allows me to do what I do best: listen and connect. It formalizes the empathetic approach that I believe is the most critical, yet often overlooked, part of a mother's journey.",
        },
        {
          title: "Beyond the Clinic",
          body: "I volunteer at a local animal shelter on weekends; caring for the voiceless is a passion of mine. I find journaling to be incredibly therapeutic and I encourage my patients to do the same. I'm currently reading a lot of Brene Brown's work on vulnerability and courage.",
        },
      ]}
      favorites={[
        { icon: "📖", label: "Favourite Book", value: "Daring Greatly by Brene Brown" },
        { icon: "🎵", label: "Favourite Singer", value: "Shreya Ghoshal" },
        { icon: "🐶", label: "Favourite Pastime", value: "Volunteering at the animal shelter\nReflective journaling" },
      ]}
    />
  );
};

export default DrGayatriNavaleContent;
